import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';

export const tooltip: OverWritable = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: theme.palette.grey[isLightTheme(theme) ? 800 : 700],
      }),
      arrow: ({ theme }) => ({
        color: theme.palette.grey[isLightTheme(theme) ? 800 : 700],
      }),
    },
  },
};
